

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _credit = require('xo-models/src/credit');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$capeRedirectUtil', function () {
    return {
        handleCapeRouting: function handleCapeRouting(checkoutSession, checkoutCart, token) {
            var fundingInstruments = void 0;
            var isCreditInWallet = void 0;

            if (checkoutCart.isBillingNoPurchase()) {
                fundingInstruments = checkoutSession.futurePaymentInstruments;
                isCreditInWallet = checkoutSession.futurePayment && checkoutSession.futurePayment.isCreditInWallet;
            } else {
                fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
                isCreditInWallet = fundingInstruments && _squid.$util.find(fundingInstruments, function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
            }

            var creditDataModel = _credit.$CreditDataModel.instance(token);
            var isCapeReturnKey = creditDataModel.getCapeKey();
            var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');
            var isPPCEligible = checkoutSession.creditOffer;

            // User does not have any FI in wallet but they choose to pay in full.
            // Show add card contingency page instead of redirecting to CAPE.

            if (checkoutSession.isCreditPromoted && !fundingInstruments && creditDataModel.payInFull || !fundingInstruments && !isPPCEligible) {

                return _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
            }

            // Handle case where it was timeout and status is to go back to cape
            else if (isCreditInWallet || isCapeReturn || creditDataModel.payInFull) {
                    return _uiRouter.$state.go('checkout.review');
                }

                // Handle acquisition customer send to CAPE
                else if (!isCreditInWallet && isPPCEligible) {
                        return _uiRouter.$state.go('checkout.redirectToCape', {}, { location: false });
                    } else {
                        // show error message
                        return _uiRouter.$state.go('checkout.review');
                    }
        }
    };
});

_squid.$util;

_uiRouter.$state;

_credit.$CreditDataModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/util.js
// module id = ./pages/xo-login/util.js
// module chunks = 0